import { getClassTempListByCityId, getClassTempList,getClassTempList2, postNewClassTemp, deleteClassTemp, updateClassTemp } from "@/services/class-temp.service";
import moment from "moment";
import { setPaginationDetails, formatDateEditZone } from "@/utils/utils";

// initial state
const state = () => ({
  classTempModel: {
    timePeriod: null,
  },
  classTempList: [],
});

// mutations
const mutations = {
  setClassTempModel(state, data) {
    state.classTempModel = data;
  },
  setClassTempList(state, data) {
    state.classTempList = data;
  },
};

// actions
const actions = {
  async loadClassTempListByCityId(vuexContext, obj) {
    return await getClassTempListByCityId(obj).then((response) => {
      let data = response.data;

      data.map((item, index) => {
        item.index = index + 1;
        item.newStartDate = moment(item.startDate).format("HH:mm");
        item.newEndDate = moment(item.endDate).format("HH:mm");
        item.label = `${item.newStartDate} - ${item.newEndDate}`;
      });

      vuexContext.commit("setClassTempList", data);
      return data;
    });
  },

  async loadClassTempList(vuexContext, co) {
    return await getClassTempList(co).then((response) => {
      let data = response.data.result.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((item, index) => {
        item.index = index + 1;
        item.educationTypeId = item.educationType.id;
        item.paidId = item.paid.id;
        item.levelsId = item.levels.id;
        item.label = `${item.newStartDate} - ${item.newEndDate}`;

        item.classDayAndTime = "";
        item.dayAndTime = "";

        item.classDayAndTimeWithDetails = `${item.levels.description} / ${item.timePeriod} / `;
        item.classDayAndTimeTsi = `(TSİ) / `;

        if (item.classDayAndTimeList.length < 1) {
          item.classDayAndTime = "Veri girişi yapılmadı.";
          item.dayAndTime = "Veri girişi yapılmadı.";
        }

        item.classDayAndTimeList.forEach((dayTime, index) => {
          //TSİ
          item.classDayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, item.timePeriod, "+03:00")} - ${formatDateEditZone(dayTime.endDate, item.timePeriod, "+03:00")}
          `;

          item.classDayAndTimeTsi += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, item.timePeriod, "+03:00")} - ${formatDateEditZone(dayTime.endDate, item.timePeriod, "+03:00")}
          `;

          item.classDayAndTimeWithDetails += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, "+03:00", "+03:00")} - ${formatDateEditZone(dayTime.endDate, "+03:00", "+03:00")}
          `;

          if (index < item.classDayAndTimeList.length - 1) {
            item.classDayAndTime += " / ";
          }

          //Normal
          item.dayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, "+03:00", "+03:00")} -  ${formatDateEditZone(dayTime.endDate, "+03:00", "+03:00")}
          `;
          if (index < item.classDayAndTimeList.length - 1) {
            item.dayAndTime += " / ";
          }
        });

        item.newName = item.name + " / " + item.timePeriod;
      });
      // console.log(items);
      setPaginationDetails(co, totalCount, totalPages);
      vuexContext.commit("setClassTempList", items);
      return items;
    });
  },

  async loadClassTempList2(vuexContext, co) {
    return await getClassTempList2(co).then((response) => {
      //console.log("ress",response);
      let data = response.data.data;

      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((item, index) => {
        item.index = index + 1;
        // item.educationTypeId = item.educationType.id;
        // item.paidId = item.paid.id;
        // item.levelsId = item.levels.id;
        // item.label = `${item.newStartDate} - ${item.newEndDate}`;

        item.classDayAndTime = "";
        item.dayAndTime = "";

        item.classDayAndTimeWithDetails = `${item.levelName} / ${item.timePeriod} / `;
        item.classDayAndTimeTsi = `(TSİ) / `;

        if (item.classDayAndTimeDto == null || item.classDayAndTimeDto.length < 1) {
          item.classDayAndTime = "Veri girişi yapılmadı.";
          item.dayAndTime = "Veri girişi yapılmadı.";
        }
        if(item.classDayAndTimeDto != null){
        item.classDayAndTimeDto.forEach((dayTime, index) => {
          //TSİ
          item.classDayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, item.timePeriod, "+03:00")} - ${formatDateEditZone(dayTime.endDate, item.timePeriod, "+03:00")}
          `;

          item.classDayAndTimeTsi += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, item.timePeriod, "+03:00")} - ${formatDateEditZone(dayTime.endDate, item.timePeriod, "+03:00")}
          `;

          item.classDayAndTimeWithDetails += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, "+03:00", "+03:00")} - ${formatDateEditZone(dayTime.endDate, "+03:00", "+03:00")}
          `;
        
          if (item.classDayAndTimeDto == null || index < item.classDayAndTimeDto.length - 1) {
            item.classDayAndTime += " / ";
          }

          //Normal
          item.dayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, "+03:00", "+03:00")} -  ${formatDateEditZone(dayTime.endDate, "+03:00", "+03:00")}
          `;
          if (item.classDayAndTimeDto == null || index < item.classDayAndTimeDto.length - 1) {
            item.dayAndTime += " / ";
          }
        });
      }
        item.newName = item.name + " / " + item.timePeriod;
      });
      // console.log(items);
      setPaginationDetails(co, totalCount, totalPages);
      vuexContext.commit("setClassTempList", items);
      return items;
    });
  },

  async postNewClassTemp(vuexContext, classTempModel) {
    return await postNewClassTemp(classTempModel).then((response) => {
      return response;
    });
  },

  async updateClassTemp(vuexContext, data) {
    return await updateClassTemp(data);
  },

  async deleteClassTemp(vuexContext) {
    return await deleteClassTemp(vuexContext.state.classTempModel?.id);
  },

  addClassTempList(vuexContext, data) {
    vuexContext.commit("setClassTempList", data);
  },
  addClassTempModel(vuexContext, data) {
    vuexContext.commit("setClassTempModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
